module.exports = {
  dimensions: {
    width: 180,
    height: 56
  },
  optical: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }
};